import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DsButtonVariants, Icons, IconStyles } from '@levelaccess/design-system';
import { of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ITask } from '../../../../../../../../shared/interfaces/task.interface';
import { Api } from '../../../../../../../../shared/constants/api';
import { FeatureFlagCollection } from '../../../../../../../../shared/interfaces/feature-flag.interface';
import { TaskStatusPolicy, taskStatusPolicy } from '../../../../../../../../shared/utils/task-status.policy';
import { TenantService } from '../../../../../../services/tenant.service';

@Component({
  selector: 'app-task-status-changed-banner',
  templateUrl: './task-status-changed-banner.component.html',
  styleUrls: ['./task-status-changed-banner.component.scss'],
  standalone: false,
})
export class TaskStatusChangedBannerComponent implements OnInit, OnDestroy {
  @Input()
  public task: ITask;

  @Output()
  public closeBanner: EventEmitter<void> = new EventEmitter<void>();

  public readonly Icons: typeof Icons = Icons;
  public IconStyles: typeof IconStyles = IconStyles;
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public statusPolicy: TaskStatusPolicy = taskStatusPolicy(false);
  private subscription: Subscription = new Subscription();

  constructor(private tenantService: TenantService) {}

  public ngOnInit(): void {
    this.subscription.add(
      this.tenantService
        .getTenantFeatureFlag(FeatureFlagCollection.separatedBacklogReopenedStatus)
        .pipe(catchError(() => of(false)))
        .subscribe((separated: boolean) => {
          this.statusPolicy = taskStatusPolicy(separated);
        }),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public get taskLink(): string {
    if (this.task) {
      return `/${Api.projects}/${this.task.projectId}/${Api.tasks}/${this.task._id}`;
    }
    this.closeBanner.emit();
    return '';
  }
}
